export function dispatchCustomEvent(target, eventName, detail=null, bubbles=true) {
    const event = new CustomEvent(eventName, { detail, bubbles });
    target.dispatchEvent(event);
}